import TeamService from 'src/modules/team/teamService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/store';

const prefix = 'TEAM_VIEW';

const teamViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: teamViewActions.FIND_STARTED,
      });

      const record = await TeamService.find(id);

      dispatch({
        type: teamViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: teamViewActions.FIND_ERROR,
      });

      getHistory().push('/team');
    }
  },
};

export default teamViewActions;
